import { Link } from "react-router-dom";
import type { Drama } from "@/mocks/dramas";

interface DramaCardProps {
  drama: Drama;
  rank?: number;
}

export default function DramaCard({ drama, rank }: DramaCardProps) {
  return (
    <Link
      to={`/detail/${drama.id}`}
      className="group flex flex-col overflow-hidden rounded-lg border border-background-200 bg-background-50 transition-all hover:border-primary-300 hover:-translate-y-0.5"
    >
      <div className="relative w-full overflow-hidden" style={{ aspectRatio: "2 / 3" }}>
        <img
          src={drama.poster}
          alt={`${drama.title} 海报`}
          title={`${drama.title} 电视剧海报`}
          className="h-full w-full object-cover object-top transition-transform duration-500 group-hover:scale-105"
        />
        <div className="absolute inset-0 bg-gradient-to-t from-secondary-950/70 via-transparent to-transparent"></div>
        {rank !== undefined && (
          <span className="absolute left-2 top-2 flex h-7 min-w-7 items-center justify-center rounded-md bg-accent-500 px-1.5 font-label text-sm font-bold text-primary-950">
            {rank}
          </span>
        )}
        <span className="absolute right-2 top-2 rounded-md bg-secondary-950/70 px-2 py-0.5 font-label text-xs font-medium text-background-50">
          {drama.year}
        </span>
        <div className="absolute bottom-2 left-2 right-2 flex items-center justify-between">
          <span className="flex items-center gap-1 rounded-md bg-secondary-950/60 px-2 py-0.5 text-xs text-accent-300">
            <i className="ri-fire-line"></i>
            {drama.hot}
          </span>
          <span className="rounded-md bg-secondary-950/60 px-2 py-0.5 text-xs text-background-50">
            全 {drama.episodes} 集
          </span>
        </div>
      </div>
      <div className="flex flex-1 flex-col gap-2 p-3 md:p-4">
        <h3 className="font-heading text-sm md:text-base font-bold text-foreground-950 line-clamp-1 group-hover:text-primary-600 transition-colors">
          {drama.title}
        </h3>
        <div className="flex flex-wrap items-center gap-1.5">
          {drama.types.slice(0, 2).map((t) => (
            <span
              key={t}
              className="rounded-md bg-secondary-100 px-2 py-0.5 text-xs text-secondary-900"
            >
              {t}
            </span>
          ))}
          <span className="text-xs text-foreground-500">{drama.region}</span>
        </div>
        <p className="mt-auto font-label text-xs text-foreground-500">更新于 {drama.updatedAt}</p>
      </div>
    </Link>
  );
}